export default __webpack_public_path__ + "static/media/practice-level-1.6901a772.svg";